import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import Sesion from './modules/sesionDrive/sesion';
import UserProfile from './modules/usuario/Usuario';
import DrivePrincipal from './modules/drive/DrivePrincipal';
import ProtectedRoute from './components/ProtectedRoute';
import FormularioEnvioArchivos from './modules/home/FormularioEnvioArchivos';
function App() {
  console.log('App component rendered!');
  console.log('Current path:', window.location.pathname);
  return (
    <BrowserRouter>    
      <Routes>
        <Route path="/" element={<FormularioEnvioArchivos />} />
        <Route path="/sesion" element={<Sesion />} />
        {/* Protected routes */}
        <Route 
          path="/drive" 
          element={
            <ProtectedRoute>
              <DrivePrincipal />
            </ProtectedRoute>
          } 
        />
        <Route path="/cuenta" element={<UserProfile />} />
        <Route path="*" element={<div>404 - Route not found. Current path: {window.location.pathname}</div>} />    
      </Routes>
    </BrowserRouter>
  );
}

export default App;